module.exports = "/packs/circle-progress-indicator-fcbc16e940de58dbb6e8d4e568d63899.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/assets/images/circle-progress-indicator.svg
// module id = ./app/javascript/packs/Shared/assets/images/circle-progress-indicator.svg
// module chunks = 1